<template>
  <b-container fluid class="p-0 mt-2">
    <b-card class="mx-3" no-body>
      <template #header>
        <h6 class="mb-0 text-center">
          <span class="titulo-sagres font-weight-bold">{{
            cumputedTitle
          }}</span>
        </h6>
      </template>
      <b-tabs no-card>
        <validation-observer ref="validationobserver" v-slot="{ handleSubmit }">
          <b-form class="ml-4 mr-3" @submit.prevent="handleSubmit(createUg)">
            <h6 class="mb-3 mr-3 text-left">
              <btn-voltar />
              <b-button
                v-if="!isDetail"
                class="float-right m-1"
                size="sm"
                type="submit"
              >
                <font-awesome-icon icon="save" />
                Salvar
              </b-button>
            </h6>
            <b-row class="w-100">
              <b-col cols="12" lg="6">
                <default-form-validation-provider
                  v-slot="defaultState"
                  label="Nome da UG"
                >
                  <b-form-input
                    id="input-nm"
                    v-model="ug.nmNome"
                    :state="defaultState.state"
                    :disabled="!!isDetail"
                    autofocus
                  />
                </default-form-validation-provider>
              </b-col>
              <b-col cols="12" lg="3">
                <default-form-validation-provider
                  v-slot="defaultState"
                  label="Sigla da UG"
                >
                  <b-form-input
                    id="input-sigla"
                    v-model="ug.nmSigla"
                    :state="defaultState.state"
                    :disabled="!!isDetail"
                  />
                </default-form-validation-provider>
              </b-col>
              <b-col cols="12" lg="3">
                <default-form-validation-provider
                  v-slot="defaultState"
                  label="Código da UG"
                >
                  <b-form-input
                    id="input-cod-ug"
                    v-model="ug.codUgSagres"
                    :state="defaultState.state"
                    :disabled="!!isDetail"
                    maxlength="6"
                    minlength="6"
                  />
                </default-form-validation-provider>
              </b-col>
              <b-col cols="12" lg="3">
                <default-form-validation-provider
                  v-slot="defaultState"
                  label="CNPJ da UG"
                >
                  <b-form-input
                    id="input-cnpj"
                    v-model="ug.nuCnpj"
                    :state="defaultState.state"
                    :disabled="!!isDetail"
                  />
                </default-form-validation-provider>
              </b-col>
              <b-col cols="12" lg="3">
                <default-form-validation-provider
                  v-slot="defaultState"
                  label="Mês de Início"
                >
                  <b-form-select
                    id="select-mes"
                    :state="defaultState.state"
                    :options="listaMeses"
                    v-model="ug.mesInicio"
                    :disabled="!!isDetail"
                  />
                </default-form-validation-provider>
              </b-col>
              <b-col cols="12" lg="3">
                <default-form-validation-provider
                  v-slot="defaultState"
                  label="Ano de Início"
                >
                  <b-form-input
                    id="input-ano"
                    v-model="ug.anoInicio"
                    :state="defaultState.state"
                    :disabled="!!isDetail"
                    type="number"
                    min="1900"
                    :max="anoAtual"
                  />
                </default-form-validation-provider>
              </b-col>
              <b-col cols="12" lg="3">
                <b-overlay :show="loadingNatJu">
                  <default-form-validation-provider
                    v-slot="defaultState"
                    label="Natureza Jurídica"
                  >
                    <b-form-select
                      id="select-nat-jurid"
                      :state="defaultState.state"
                      :options="listaNatJu"
                      v-model="ug.idNaturezaJuridica"
                      :disabled="!!isDetail"
                    />
                  </default-form-validation-provider>
                </b-overlay>
              </b-col>
              <b-col cols="12" lg="3">
                <b-overlay :show="loadingPoder">
                  <default-form-validation-provider
                    v-slot="defaultState"
                    label="Poder"
                  >
                    <b-form-select
                      id="select-nat-poder"
                      :state="defaultState.state"
                      :options="listaPoder"
                      v-model="ug.idPoder"
                      :disabled="!!isDetail"
                    />
                  </default-form-validation-provider>
                </b-overlay>
              </b-col>
              <b-col cols="12" lg="3">
                <b-overlay :show="loadingTipos">
                  <default-form-validation-provider
                    v-slot="defaultState"
                    label="Tipo da UG"
                  >
                    <b-form-select
                      id="select-tipo-ug"
                      :state="defaultState.state"
                      :options="listaTipos"
                      v-model="ug.idTipoUnidadegestora"
                      :disabled="!!isDetail"
                    />
                  </default-form-validation-provider>
                </b-overlay>
              </b-col>
              <b-col cols="12" lg="3">
                <b-overlay :show="loadingMunic">
                  <default-form-validation-provider
                    v-slot="defaultState"
                    label="Município"
                  >
                    <b-form-select
                      id="select-municipio"
                      :state="defaultState.state"
                      :options="listaMunic"
                      v-model="ug.idMunicipio"
                      :disabled="!!isDetail"
                      @change="getAllUgsSuperiores"
                    />
                  </default-form-validation-provider>
                </b-overlay>
              </b-col>
              <b-col cols="12" lg="3">
                <b-overlay :show="loadingEsfer">
                  <default-form-validation-provider
                    v-slot="defaultState"
                    label="Esfera"
                  >
                    <b-form-select
                      id="select-esfera"
                      :state="defaultState.state"
                      :options="listaEsfer"
                      v-model="ug.idEsfera"
                      :disabled="!!isDetail"
                      @change="getAllUgsSuperiores"
                    />
                  </default-form-validation-provider>
                </b-overlay>
              </b-col>
              <b-col cols="12" lg="6">
                <b-overlay :show="loadingUgSup">
                  <default-form-validation-provider
                    v-slot="defaultState"
                    label="UG Superior (opcional)"
                    rules=""
                  >
                    <b-form-select
                      id="select-ug-superior"
                      :state="defaultState.state"
                      :options="listaUgSup"
                      v-model="ug.idUnidadegestoraSuperior"
                      :disabled="!!isDetail"
                    />
                  </default-form-validation-provider>
                </b-overlay>
              </b-col>
              <b-col v-if="ug.idUnidadegestoraSuperior" cols="12" lg="3">
                <default-form-validation-provider
                  v-slot="defaultState"
                  label="Entrega Folha de Pagamento"
                >
                  <b-form-select
                    id="select-entrega-fl-pgmnt"
                    :state="defaultState.state"
                    :options="listaFlPgt"
                    v-model="ug.stEntregaFolhaPagto"
                    :disabled="!!isDetail"
                  />
                </default-form-validation-provider>
              </b-col>
            </b-row>
          </b-form>
        </validation-observer>
      </b-tabs>
    </b-card>
  </b-container>
</template>

<script lang="ts">
import { Component, Vue } from "vue-property-decorator";
import { mixins } from "vue-class-component";
import { UtilsTS } from "@/utilsts";
import { ValidationObserver } from "vee-validate";
import DefaultFormValidationProvider from "@/components/shared/DefaultFormValidationProvider.vue";
import BtnVoltar from "@/components/shared/BtnVoltar.vue";
import { SelectValue } from "@/types/select-value";
import { UG } from "@/types/administracao/ug/ug";
import ugService from "@/services/administracao/ugService";
import municipioService from "@/services/administracao/municipioService";
import { Municipio } from "@/types/administracao/municipio";
import { EnumEntregaFlPgmnt } from "@/types/administracao/ug/enum-entrega-fl-pgmnt";
import { store } from "@/store";

const CompProps = Vue.extend({
  name: "CriarUnidadeGestora",
  components: {
    ValidationObserver,
    DefaultFormValidationProvider,
    BtnVoltar,
  },
  props: {
    idUg: {
      type: String,
      required: false,
      default: null,
    },
    isDetail: {
      type: String,
      required: false,
      default: null,
    },
  },
});

@Component
export default class CriarUnidadeGestora extends mixins(UtilsTS, CompProps) {
  ug = new UG();

  listaMeses: SelectValue[] = [];
  listaNatJu: SelectValue[] = [];
  listaPoder: SelectValue[] = [];
  listaMunic: SelectValue[] = [];
  listaTipos: SelectValue[] = [];
  listaEsfer: SelectValue[] = [];
  listaUgSup: SelectValue[] = [];
  listaFlPgt: SelectValue[] = [
    { value: null, text: "Selecione a entrega" },
    { value: EnumEntregaFlPgmnt.NAO, text: "Não" },
    { value: EnumEntregaFlPgmnt.SIM, text: "Sim" },
    { value: EnumEntregaFlPgmnt.CENTRALIZADA, text: "Centralizada" },
  ];

  loadingNatJu = false;
  loadingPoder = false;
  loadingMunic = false;
  loadingTipos = false;
  loadingEsfer = false;
  loadingUgSup = false;

  anoAtual = new Date().getFullYear();

  get cumputedTitle(): string {
    return this.idUg
      ? this.isDetail
        ? "Detalhes da Unidade Gestora"
        : "Editar Unidade Gestora"
      : "Criar Unidade Gestora";
  }

  async createUg(): Promise<void> {
    try {
      store.blockScreen = true;
      if (this.ug.codUgSagres) {
        this.ug.codUgSagres = this.apenasNumeros(this.ug.codUgSagres);
        if (this.ug.codUgSagres === null || this.ug.codUgSagres.length !== 6) {
          this.$toast.error("O código da UG deve conter 6 dígitos numéricos.");
          return;
        }
      }
      this.ug.nuCnpj = this.apenasNumeros(this.ug.nuCnpj) ?? "";
      this.ug.idUgSuperiorFolha =
        this.ug.idUnidadegestoraSuperior &&
        this.ug.stEntregaFolhaPagto === EnumEntregaFlPgmnt.CENTRALIZADA
          ? this.ug.idUnidadegestoraSuperior
          : null;
      this.ug.mesInicio = Number(this.ug.mesInicio);
      this.ug.anoInicio = Number(this.ug.anoInicio);

      if (this.ug.idUnidadegestoraSuperior === null)
        this.ug.stEntregaFolhaPagto = EnumEntregaFlPgmnt.NAO;

      if (this.idUg && !this.isDetail) {
        const response = await ugService.editUg(this.ug);
        if (response)
          this.$toast.success("Unidade Gestora editada com sucesso!");
      } else {
        const response = await ugService.createUg(this.ug);
        if (response) {
          this.$toast.success("Unidade Gestora criada com sucesso!");
          this.$router.push(
            `/administracao/ver-unidade-gestora/${response.id}/true`
          );
        }
      }
    } catch (error: unknown) {
      this.tratarError(error);
    } finally {
      store.blockScreen = false;
    }
  }

  async getUgById() {
    try {
      store.blockScreen = true;
      this.ug = await ugService.getUgById(Number(this.idUg));
      if (typeof this.ug.idUnidadegestoraSuperior !== "number")
        this.ug.idUnidadegestoraSuperior = null;
    } catch (error: unknown) {
      this.tratarError(error);
    } finally {
      store.blockScreen = false;
    }
  }

  async getAllNaturezaJuridica(): Promise<void> {
    try {
      this.loadingNatJu = true;
      const response = await ugService.getAllNaturezaJuridica();
      this.listaNatJu = response.map((nat) => ({
        value: nat.IdNaturezaJuridica,
        text: this.capitalize(nat.NmNome),
      }));
      this.listaNatJu.unshift({
        value: null,
        text: "Selecione o tipo",
      });
      this.ug.idNaturezaJuridica = null;
    } catch (error: unknown) {
      this.tratarError(error);
    } finally {
      this.loadingNatJu = false;
    }
  }

  async getAllPoderes(): Promise<void> {
    try {
      this.loadingPoder = true;
      const response = await ugService.getAllPoderes();
      this.listaPoder = response.map((nat) => ({
        value: nat.IdPoder,
        text: this.capitalize(nat.NmNome),
      }));
      this.listaPoder.unshift({
        value: null,
        text: "Selecione o poder",
      });
      this.ug.idPoder = null;
    } catch (error: unknown) {
      this.tratarError(error);
    } finally {
      this.loadingPoder = false;
    }
  }

  async getListaMunicipios(): Promise<void> {
    try {
      this.loadingMunic = true;
      const response = await municipioService.getMunicipios(29);
      this.listaMunic = response.map((a: Municipio) => {
        return { text: this.capitalize(a.NM_NOME), value: a.ID_MUNICIPIO };
      });
      this.listaMunic.unshift({
        value: null,
        text: "Selecione o município",
      });
      this.ug.idMunicipio = null;
    } catch (error: unknown) {
      this.tratarError(error);
    } finally {
      this.loadingMunic = false;
    }
  }

  async getAllTiposUgs(): Promise<void> {
    try {
      this.loadingTipos = true;
      const response = await ugService.getAllTiposUgs();
      this.listaTipos = response.map((tp) => ({
        value: tp.IdTipoUnidadeGestora,
        text: tp.NmNome,
      }));
      this.listaTipos.unshift({
        value: null,
        text: "Selecione o tipo",
      });
      this.ug.idTipoUnidadegestora = null;
    } catch (error: unknown) {
      this.tratarError(error);
    } finally {
      this.loadingTipos = false;
    }
  }

  async getAllEsferas(): Promise<void> {
    try {
      this.loadingEsfer = true;
      const response = await ugService.getAllEsferas();
      this.listaEsfer = response.map((esf) => ({
        value: esf.IdEsfera,
        text: this.capitalize(esf.NmNome),
      }));
      this.listaEsfer.unshift({
        value: null,
        text: "Selecione a esfera",
      });
      this.ug.idEsfera = null;
    } catch (error: unknown) {
      this.tratarError(error);
    } finally {
      this.loadingEsfer = false;
    }
  }

  async getAllUgsSuperiores(): Promise<void> {
    try {
      this.loadingUgSup = true;
      const response = await ugService.getAllUgsSuperiores(
        this.ug.idEsfera ?? 0,
        this.ug.idMunicipio ?? 0
      );
      this.listaUgSup = response.map((ugS) => ({
        value: ugS.Id,
        text: this.capitalize(ugS.NmNome),
      }));
      this.listaUgSup.unshift({
        value: null,
        text: "Selecione a UG Superior",
      });
      this.ug.idUnidadegestoraSuperior = null;
    } catch (error: unknown) {
      this.tratarError(error);
    } finally {
      this.loadingUgSup = false;
    }
  }

  montaListaMeses() {
    this.listaMeses = this.getListaMeses();
    this.listaMeses.unshift({ value: null, text: "Selecione o ano" });
    this.ug.mesInicio = null;
  }

  async mounted() {
    try {
      store.blockScreen = true;
      this.ug.stEntregaFolhaPagto = null;
      this.montaListaMeses();
      await this.getListaMunicipios();
      await this.getAllEsferas();
      await this.getAllNaturezaJuridica();
      await this.getAllPoderes();
      await this.getAllTiposUgs();
      await this.getAllUgsSuperiores();
      if (this.idUg) await this.getUgById();
    } catch (error: unknown) {
      this.tratarError(error);
    } finally {
      store.blockScreen = false;
    }
  }
}
</script>
